module.exports = __webpack_public_path__ + "img/banner-3-3.79268533.png";